import React from 'react'

const Header = () => {
  return (
    <header>
                <div>
                    <h1 className='font-bold uppercase tracking-wide text-xl mb-3 text-center'>RUKUN TETANGGA (RT) 05 - RUKUN WARGA (RW) 24</h1>
                    <h1 className='font-bold uppercase tracking-wide text-xl mb-3 text-center'>KOMPLEK MEKAR SARI ENDAH</h1>
                    <h1 className='font-bold uppercase tracking-wide text-xl mb-3 text-center'>KEL. / KEC. BALEENDAH - KAB.BANDUNG</h1>
                    <div className='border-t-2 border-gray-800'></div>
                </div>
    </header>
  )
}

export default Header